"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Regions = void 0;
const allRegions_1 = require("./allRegions");
class Regions {
    constructor(region) {
        this.displayName = () => {
            return this.region.displayName;
        };
        this.totalRegions = allRegions_1.RegionsDetails.length;
        const [currentRegion] = allRegions_1.RegionsDetails.filter(f => f.name === region);
        this.region = currentRegion;
    }
    static allRegionNames() {
        return allRegions_1.RegionsDetails.map(region => region.name);
    }
    static allContinent() {
        const all = allRegions_1.RegionsDetails.map(region => region.continentCode);
        return [...new Set(all)];
    }
    static allRegions() {
        return allRegions_1.RegionsDetails.map(region => {
            const { continentCode, countryCode, name, description, displayName, } = region;
            return {
                continentCode,
                countryCode,
                name,
                description,
                displayName,
            };
        });
    }
    static allEndpoints() {
        return allRegions_1.RegionsDetails.map(region => region.endPoint);
    }
    static allMarkers() {
        const markers = allRegions_1.RegionsDetails.map(region => {
            return {
                markerOffset: Regions.markerOffset,
                name: region.displayName,
                region: region.name,
                coordinates: region.coordinates,
            };
        });
        return markers;
    }
    static RegionsByKey() {
        const regions = {};
        allRegions_1.RegionsDetails.map(region => {
            regions[region.name] = region;
        });
        return regions;
    }
}
exports.Regions = Regions;
Regions.markerOffset = 20;
//# sourceMappingURL=index.js.map